export default {
  user : {},
  canConnectToSocket: false,
  canUseUserOnlineChecker: false,
  userSocketConnection: null,
  integratorSocketConnection: null,
}
